(function () {
    'use strict';

    var backgroundListControl = {
        restrict: 'EAC',
        replace: true,
        transclude: true,
        templateUrl: 'app/entities/components/background-list.html',
        controllerAs: 'vm',
        bindings: {
            onColor: '&',
            onImage: '&'
        },
        controller: ['$scope', 'ThemeClassify', 'Backgrounds', '$stateParams',
            function ($scope, ThemeClassify, Backgrounds, $stateParams) {
                var vm = this;
                vm.storeId = $stateParams.storeId;
                vm.$onInit = function() {
                    classifyInit();
                }
                //分类
                function classifyInit(){
                    ThemeClassify.getAllByCondition4({
                        type: 'Background',
                        storeId: vm.storeId
                    }, function (res) {
                        vm.bgImglabels = res.data;
                        vm.bgImgPage = 0;
                        vm.bgImgList = [];
                        bgImgInit(res.data[0])
                    });
                }
                vm.colorArr1 = ['#ffffff', '#666666', '#7babaf', '#e69594', '#93a9da', '#eac8fb'];
                vm.colorArr2 = ['#000000', '#666666', '#a8a8a8', '#d9d9d9', '#ffffff', '#647c6e', '#ff5b5c', '#ffbd4a', '#fef952', '#99e264', '#36b72a', '#44d9e5', '#c27171', '#2fb3ff', '#b760a6'];
        
                vm.bgImgList = [];
                vm.bgImgPage = 0;
                vm.bgImgChooseId = "";
                $scope.showbgImgdocLabels = false;
                vm.bgImglabelCb = bgImglabelCb;
                function bgImgInit(item) {
                    vm.bgImgChooseId = item;
                    Backgrounds.byCondition3({
                        items: [
                            {key: "themeClassify.id", op: "=", value: item.id}],
                        page: vm.bgImgPage,
                        size: vm.itemsPerPage
                    }, function (res, headers) {
                        angular.forEach(res.data, function (resp) {
                            var arr = {
                                name: resp.name,
                                identifier: localStorage.getItem('editor-domain') + resp.identifier,
                                provider: resp.provider,
                                themeClassifyName: resp.themeClassifyName,
                                themeClassifyId: resp.themeClassifyId,
                                resource: {
                                    identifier: localStorage.getItem('editor-domain') + resp.identifier,
                                    provider: resp.provider,
                                }
                            }
                            vm.bgImgList.push(arr);
                        })
                        var _sum = headers('X-Total-Count');
                        if(vm.bgImgList.length < _sum){
                            vm.bgImgFulfill = true;
                        }else {
                            vm.bgImgFulfill = false;
                        }
                    }, function () {
                    })
                }
                function bgImglabelCb(item){
                    vm.bgImgList = [];
                    vm.bgImgPage = 0;
                    bgImgInit(item)
                }
                $scope.loadMoreBgImg = function () {
                    vm.bgImgPage++;
                    bgImgInit(vm.bgImgChooseId)
                }
                $scope.showMorebgImgdocLabels = function () {
                    $scope.showbgImgdocLabels = !$scope.showbgImgdocLabels;
                }

                
                $scope.chooseBgColor = function(color){
                    if(vm.onColor){vm.onColor({text:color})}
                }
                $scope.chooseColor = function () {
                    if (vm.bgColor) {
                        $scope.chooseBgColor({text:vm.bgColor});
                    }
                    vm.bgColor = '#000000';
                }
                $scope.chooseBgimg = function(data){
                    if(vm.onImage){vm.onImage({text:data})}
                };
            }]
    };

    angular.module('editorApp')
        .component('backgroundList', backgroundListControl);

})();
